// Supabase liefert höchstens 1000 Zeilen je Abfrage – darum seitenweise laden.

export async function alleSeiten<T>(seite: (von: number, bis: number) => PromiseLike<{ data: T[] | null; error: { message: string } | null }>): Promise<T[]> {
  const GROESSE = 1000;
  const alle: T[] = [];
  for (let von = 0; ; von += GROESSE) {
    const { data, error } = await seite(von, von + GROESSE - 1);
    if (error) throw new Error(error.message);
    const teil = data ?? [];
    alle.push(...teil);
    if (teil.length < GROESSE) return alle;
  }
}
